import { handlePriceByComma } from "@/helpers/common/handlePrice";
import { handleWishList } from "@/utils/wishlist";
import { useWishlist } from "@/context/wishlist";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import AddToCart from "./buttons/AddToCart";
import AddtoWishlist from "./buttons/AddtoWishlist";
import RatingStars from "./rating";
import Link from "next/link";
import { validatePrice } from "@/helpers/product";
import AddToCompare from "../product/AddToCompare";
import CloseIcon from "../icons/CloseIcon";
import { useState } from "react";
import { event_view_item } from "@/utils/gtm";
import { isFlushDealActive, validateImgSrc } from "@/utils/global";
import NextImage from "./NextImage";
import CurrencyIcon from "../icons/CurrencyIcon";
import ProductCardCountDown from "./ProductCardCountDown";

const ProductCard = ({
  product: productObj = {},
  hit = null,
  handleOnClick = null,
  fromSwiper = false,
  onRemoveCompare,
}) => {
  const [productImg, setProductImg] = useState(null);
  const { t } = useTranslation("product");
  const { locale } = useRouter();
  const { wishlist, dispatch } = useWishlist();
  const product = hit
    ? {
        rewrite_url: hit?.["url_key"] || "",
        sku: hit?.sku || "",
        stock: {
          is_in_stock: hit?.in_stock ? true : false,
          qty: hit?.in_stock || 0,
        },
        _media_: { image: [{ image: hit?.image_url }] },
        name: [hit?.name],
        prices_with_tax: hit?.prices_with_tax,
        label: hit?.label || [],
      }
    : productObj;
  const price = validatePrice(product?.prices_with_tax);

  const { push } = useRouter();

  const textLabels =
    product?.label?.length > 0 &&
    product?.label?.filter(
      (label) =>
        label?.status === "1" &&
        !label?.["frontend_settings"]?.image &&
        !!label?.["frontend_settings"]?.label_text
    );

  return (
    <div className="relative pb-[30px] max-sm:pb-5">
      <div className="relative border rounded-md p-1 sm:p-3 bg-white text-[11px] md:text-base">
        {onRemoveCompare && (
          <div
            onClick={onRemoveCompare}
            className="bg-red absolute -end-3 -top-6 z-10 cursor-pointer rounded-md border border-[#CDCDCD] bg-white p-2"
          >
            <CloseIcon stroke="black" strokeWidth={1} width={12} height={12} />
          </div>
        )}
        <div
          className={`relative ${
            fromSwiper ? "h-24" : "h-44"
          } md:h-52 overflow-hidden flex items-center justify-center`}
          onMouseEnter={() =>
            product?._media_?.image?.at(1)?.image &&
            setProductImg(product?._media_?.image?.at(1)?.image)
          }
          onMouseLeave={() => setProductImg(null)}
        >
          {product?._media_?.image?.at(0)?.image ? (
            <NextImage
              onClick={() => {
                if (product?.rewrite_url) {
                  push(
                    product?.rewrite_url?.includes("https:/")
                      ? product?.rewrite_url
                      : `/product/${product?.rewrite_url}`
                  );
                  event_view_item(product, "select_item");
                }
                handleOnClick && handleOnClick();
              }}
              src={validateImgSrc(
                productImg ||
                  product?._media_?.image?.at(0)?.image ||
                  `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${product?.image}` ||
                  "/imgs/normal-img.png"
              )}
              height={210}
              width={210}
              className="h-[90%] w-auto object-contain rounded-t-md cursor-pointer"
              alt={product?.name?.at(0) || ""}
            />
          ) : null}
          <div className="flex flex-col">
            <AddtoWishlist
              isWishlisted={product?.sku in wishlist}
              onClick={() => {
                product?.sku in wishlist
                  ? event_view_item(product, "remove_from_wishlist")
                  : event_view_item(product, "add_to_wishlist");
                handleWishList(wishlist, product, dispatch);
              }}
            />

            {!onRemoveCompare && (
              <AddToCompare
                product={product}
                t={t}
                iconClassName={`size-6 max-sm:w-4 z-30 cursor-pointer text-secondary-800 absolute top-12 ${
                  locale == "ar" ? "left-0" : "right-0"
                }`}
              />
            )}
            {/* </div> */}
          </div>
          <div
            className={`absolute top-2 ${
              locale == "en" ? "left" : "right"
            }-2 z-20 flex items-center gap-3`}
          >
            {product?.label?.length > 0 && (
              <div>
                {product?.label?.map(
                  (label, i) =>
                    label?.status === "1" &&
                    label?.["frontend_settings"]?.image && (
                      <NextImage
                        key={i}
                        src={validateImgSrc(
                          process.env.NEXT_PUBLIC_IMG_BASEURL +
                            "/amasty/amlabel/" +
                            label?.["frontend_settings"]?.image
                        )}
                        alt={label?.name}
                        width={32}
                        height={32}
                        className="h-8"
                      />
                    )
                )}
              </div>
            )}
            {price?.specialPrice ? (
              <div className="bg-[#fc6440] text-white py-1 px-3 rounded-md text-[10px] sm:text-xs uppercase ">
                {price?.discount}% {t("Off")}
              </div>
            ) : null}
          </div>
        </div>
        <div className="max-sm:h-8 h-12 my-1.5">
          <Link
            href={`/product/${product?.rewrite_url}`}
            onClick={() => event_view_item(product, "select_item")}
            className="text-base font-normal line-clamp-2 text-start max-sm:text-xs"
          >
            {(typeof product.name == "array" && product?.name?.at(0)) ||
              product?.name ||
              "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aspernaturporro tenetur quas exercitationem fugit cupiditate dolor alias inventore natus eveniet."}
          </Link>
        </div>
        <div
          className={`my-1.5 max-sm:mb-0 flex sm:items-center justify-between  ${
            fromSwiper && "flex-col sm:flex-row"
          }`}
        >
          <div
            className={`flex items-center gap-1 ${
              productObj?.rating?.count > 0 ? "" : "invisible"
            }`}
          >
            {
              <RatingStars
                totalRatings={productObj?.rating?.rating || 0}
                rateClassName="text-sm"
              />
            }
            {productObj?.rating?.rating &&
              productObj?.rating?.rating !== "0.0" && (
                <p className="text-sm text-gray-500">
                  ({productObj?.rating?.count})
                </p>
              )}
          </div>
        </div>

        <div className="my-1.5 max-sm:mb-0 flex items-center gap-3 h-6">
          <p className="whitespace-nowrap flex items-center gap-1 text-[11px] md:text-base text-secondary-800 font-extrabold">
            {handlePriceByComma(price?.specialPrice || price?.originalPrice)}{" "}
            <CurrencyIcon className="size-2.5 lg:size-4" />
          </p>

          {price?.specialPrice ? (
            <p className="whitespace-nowrap flex items-center gap-1 text-[11px] md:text-base text-zinc-400 line-through">
              {handlePriceByComma(price?.originalPrice)}{" "}
              <CurrencyIcon className="size-2.5 lg:size-4" />
            </p>
          ) : (
            ""
          )}
        </div>

        <div className="mb-2 min-h-5">
          {textLabels?.length > 0 && (
            <p className="truncate bg-green-100 text-[10px] sm:text-xs py-0.5 ps-1">
              {textLabels?.[0]?.["frontend_settings"]?.label_text}
            </p>
          )}
        </div>

        <div className="grid grid-cols-12 gap-2 my-2">
          <div className="col-span-3">
            <NextImage
              className="rounded-sm w-auto min-h-5 my-auto max-h-5 sm:min-h-7 sm:max-h-7 h-[22px] object-contain"
              src={`/imgs/payments/baseeta-${locale}-v2.png`}
              width={50}
              loading="lazy"
              alt="Baseeta"
              height={16}
            />
          </div>
          <span className="text-zinc-400 mx-auto"> | </span>
          <div className="col-span-3">
            <NextImage
              className="rounded-sm w-auto h-[22px] my-auto object-contain min-h-5 max-h-5 sm:min-h-7 sm:max-h-7"
              src={`/imgs/payments/tamara-${locale}-v2.png`}
              width={50}
              height={16}
              loading="lazy"
              alt="Tamara"
            />
          </div>
          <span className="text-zinc-400 mx-auto"> | </span>
          <div className="col-span-3">
            <NextImage
              className="rounded-sm w-auto h-[22px] my-auto object-contain min-h-5 max-h-5 sm:min-h-7 sm:max-h-7"
              src={`/imgs/payments/tabby-v2.png`}
              width={50}
              height={16}
              loading="lazy"
              alt="Tabby"
            />
          </div>
        </div>
        <AddToCart {...{ product }} />
      </div>
      {product?.flush_deals_ends_at &&
        product?.flush_deals_start_from &&
        isFlushDealActive(
          product?.flush_deals_start_from,
          product?.flush_deals_ends_at
        ) && (
          <ProductCardCountDown
            flash_sale_end_date={product?.flush_deals_ends_at}
          />
        )}
    </div>
  );
};

export default ProductCard;
